// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34P0z","productName":"Table_productName__3Q6Lm"};